// extracted by mini-css-extract-plugin
export default {"badge-text":"zkRAQ","available-only-in-office":"Bb9Fw","eSIM":"v6blO","eSIM__icon":"eB9sj","sim--white":"arEV9"};